export const DEFAULT_OFFLINE_EXPIRATION_DAYS = 30

/**
 * Apply default offline-playback field values when the backend omits them.
 *
 * @param {Object} entity - VOD or Episode model instance
 */
export function ensureOfflinePlaybackDefaults (entity) {
  if (entity.offlinePlaybackEnabled == null) entity.offlinePlaybackEnabled = false
  if (entity.offlinePlaybackExpirationDays == null) entity.offlinePlaybackExpirationDays = DEFAULT_OFFLINE_EXPIRATION_DAYS
}

/**
 * Reset expiration to the default when offline playback is disabled so the
 * persisted payload matches the product default.
 *
 * @param {Object} entity - VOD or Episode model instance
 */
export function resetOfflineExpirationIfDisabled (entity) {
  if (!entity.offlinePlaybackEnabled) {
    entity.offlinePlaybackExpirationDays = DEFAULT_OFFLINE_EXPIRATION_DAYS
  }
}

function hasDrmProfiles (source) {
  return !!(source && Array.isArray(source.drmProfiles) && source.drmProfiles.length >= 1)
}

function streamRulesHaveDrm (rules) {
  if (!Array.isArray(rules)) return false
  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i]
    if (!rule) continue
    const mediaUrl = rule.then && rule.then.mediaUrl
    if (hasDrmProfiles(mediaUrl)) return true
    if (streamRulesHaveDrm(rule.$subRules)) return true
  }
  return false
}

/**
 * True when any stream source on the entity has at least one selected DRM profile.
 * Missing entity / sources / then.mediaUrl must not throw.
 *
 * @param {Object} [entity] - VOD or Episode model instance
 * @return {boolean}
 */
export function hasSelectedDrmProfile (entity) {
  if (entity == null) return false

  if (hasDrmProfiles(entity.defaultStream && entity.defaultStream.mediaUrl)) return true

  const urls = entity.urls
  if (urls && typeof urls === 'object') {
    const platforms = Object.keys(urls)
    for (let i = 0; i < platforms.length; i++) {
      if (hasDrmProfiles(urls[platforms[i]])) return true
    }
  }

  return streamRulesHaveDrm(entity.streamPolicy && entity.streamPolicy.$rules)
}
